import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ArtikelGruppen } from 'src/app/modules/webshop/store/models/artikelgruppen';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AdvertiseComponent } from '../../../advertise/advertise.component';

@Component({
    selector: 'kkis-app-webshop-top-level-nav1',
    templateUrl: './top-level-nav1.component.html',
    styleUrls: ['./top-level-nav1.component.scss']
})
export class TopLevelNav1Component implements OnInit, OnChanges {

    /* -------------------------------*/
    /* NavBox with Mat-Selection-List */
    /* -------------------------------*/

    // Input
    @Input()
    title: string

    // Input:ReihenfolgeTree
    @Input()
    reihenfolgeTree: any[];

    @Input()
    displayPath: string = "name"; // anzeige

    @Input()
    valuePath: string = "reihenfolgeWeb"; // wert

    @Input()
    isExpanded: boolean = false;

    @Input()
    minPreis: number;

    @Input()
    maxPreis: number;

    // Search
    search: string = "";

    selOption: any;

    // Settings
    public config: PerfectScrollbarConfigInterface = {};



    // @Input()
    // reihenfolgeTree: ArtikelGruppen.IArtikelGruppeListDto;

    // @Input()
    // minPreis: number;

    // @Input()
    // maxPreis: number;

    @Output()
    selectedOption: EventEmitter<string> = new EventEmitter<string>();

    // Utils
    isLoading: boolean = false;
    isTopLevelNavExpanded: boolean = true;
    isCategorySelected: boolean = false;

    // constructor() { }

    // ngOnInit(): void {
    //     this.title = "Kategorien";
    // }

    constructor(
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.title = "Kategorien".toUpperCase();
        this.isLoading = false;
    }

    ngOnChanges(changes: SimpleChanges): void {

        // if (changes.category != null && changes.category.currentValue != null) {
        //     if (changes.category.previousValue != changes.category.currentValue)  {
        //         this.category = changes.category.currentValue;
        //     }

        //     if (changes.minPreis != null && changes.minPreis.currentValue != null && changes.minPreis.previousValue != changes.minPreis.currentValue) {
        //         this.minPreis = changes.minPreis.currentValue;
        //     }
    
        //     if (changes.maxPreis != null && changes.maxPreis.currentValue != null && changes.maxPreis.previousValue != changes.maxPreis.currentValue) {
        //         this.maxPreis = changes.maxPreis.currentValue;
        //     }
        // }

        // if (changes.category != null && changes.category.currentValue != null && changes.category.previousValue != changes.category.currentValue)  {
        //     this.category = changes.category.currentValue;
        // }

        if (changes.minPreis != null && changes.minPreis.currentValue != null && changes.minPreis.previousValue != changes.minPreis.currentValue) {
            this.minPreis = changes.minPreis.currentValue;
        }

        if (changes.maxPreis != null && changes.maxPreis.currentValue != null && changes.maxPreis.previousValue != changes.maxPreis.currentValue) {
            this.maxPreis = changes.maxPreis.currentValue;
        }

    }

    clearCategoryFilter(): void {
        this.onNgModelchange(null);
    }

    onNgModelchange(event) {

        //alert('modelchange');

        if (event) {
            this.isCategorySelected = true;

            console.log('--> route to articles');
            this.router.navigate(['/articles'], {
                queryParams: {
                    category: event[0].reihenfolgeWeb,
                    minPreis: 0,
                    maxPreis: 0,
                    showAdvertise: false,
                }
            });
        } else {
            this.isCategorySelected = false;

            //this.router.navigate(['/articles']);
            console.log('--> route to articles');
            this.router.navigate(['/articles'], {
                queryParams: {               
                    showAdvertise: false,
                }
            });
        }
    }

    onSearch() {
        console.log('--> route to articles');

        if (this.search) {
            this.router.navigate(['/articles'], {
                queryParams: {
                    search: this.search.trim(),
                }
            });
        } else {
            this.router.navigate(['/articles']);
        }
    }




    //------------------------------
    // listen to child-components
    //------------------------------

    // getSelectedOption(option: string) {

    //     console.log("top-lev-nav.getselopt => ", option);

    //     // this.selectedOption.emit(option);
    // }
}
